// extracted by mini-css-extract-plugin
module.exports = {"block":"page_block__7Nx0C"};